import { CachedDataModel } from "../models/common/cached-data.model";
import { TabViewModel } from "../models/common/tab-view.model";
import { PAGE_VIEW_TYPES } from "../common/constants";
import { getStoreTabViews } from "./tabview-helper";

export const genFormCacheKey = (payload: CachedDataModel<any>) => {
    return `${payload.ModuleName}_${payload.Action}_${payload.Id}`;
}

export const generateNewTabId = (moduleType: number, tabViews: Array<TabViewModel> = getStoreTabViews()) => {
    console.log(tabViews);
    
    const listId = tabViews.filter((item) => item.identifyData.moduleType === moduleType && (item.identifyData.viewType === PAGE_VIEW_TYPES.NEW || item.identifyData.viewType === PAGE_VIEW_TYPES.SEARCH))
                                .map((item) => (Number(item.identifyData.id)));
    if(listId.length === 0) {
        return '1';
    }
    return `${Math.max.apply(Math, listId) + 1}`;
}